export default function VendorPartnerships() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const partners = [
    {
      name: 'Huntress',
      logo: 'https://public.readdy.ai/ai/img_res/b8fc8615c808bc149ac741b81e9b437d.jpg'
    },
    {
      name: 'Fortinet',
      logo: 'https://readdy.ai/api/search-image?query=Fortinet%20network%20security%20company%20official%20logo%20on%20white%20background%2C%20clean%20professional%20brand%20identity%2C%20high%20resolution%20corporate%20logo%20design%2C%20simple%20minimalist%20style&width=200&height=100&seq=fortinet-logo-001&orientation=landscape'
    },
    {
      name: 'Sophos',
      logo: 'https://readdy.ai/api/search-image?query=Sophos%20cybersecurity%20company%20official%20logo%20with%20dark%20text%20on%20light%20neutral%20background%2C%20clean%20professional%20brand%20identity%2C%20high%20resolution%20corporate%20logo%20design%2C%20simple%20minimalist%20style%20with%20visible%20contrast&width=200&height=100&seq=sophos-logo-002&orientation=landscape'
    },
    {
      name: 'Crowdstrike',
      logo: 'https://readdy.ai/api/search-image?query=Crowdstrike%20cybersecurity%20company%20official%20logo%20on%20white%20background%2C%20clean%20professional%20brand%20identity%2C%20high%20resolution%20corporate%20logo%20design%2C%20simple%20minimalist%20style&width=200&height=100&seq=crowdstrike-logo-001&orientation=landscape'
    }
  ];

  return (
    <section id="partnerships" className="py-24 bg-gradient-to-br from-gray-900 via-teal-900 to-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Vendor Spotlight
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            We partner with innovative technology companies worldwide, helping them expand their market reach and achieve sustainable growth through strategic partnerships and marketing excellence.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-2xl p-8 flex items-center justify-center hover:bg-white hover:shadow-xl transition-all duration-300 border border-gray-200 cursor-pointer h-32"
            >
              <img 
                src={partner.logo} 
                alt={`${partner.name} logo`}
                className="w-full h-full object-contain"
              />
            </div>
          ))}
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-teal-500 to-emerald-500 rounded-3xl p-12 text-center">
            <h3 className="text-3xl font-bold text-white mb-4">
              Become a Partner Vendor
            </h3>
            <p className="text-white/90 mb-8 text-lg">
              Join our network of successful technology vendors and unlock new market opportunities with our proven partnership model.
            </p>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-8 py-3 bg-white text-teal-600 font-semibold rounded-full hover:shadow-xl transition-all cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
            >
              Apply Now
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
